import { Search, SlidersHorizontal } from "lucide-react";
import type { ReactNode } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

export function FilterBar({
  searchPlaceholder = "Search...",
  right,
}: {
  searchPlaceholder?: string;
  right?: ReactNode;
}) {
  return (
    <div className="flex flex-wrap items-center gap-2">
      <Button variant="outline" size="sm" className="gap-2">
        <SlidersHorizontal className="h-4 w-4" />
        Filters
      </Button>
      <div className="relative min-w-[240px] flex-1 max-w-sm">
        <Search className="pointer-events-none absolute left-2.5 top-1/2 h-4 w-4 -translate-y-1/2 text-muted-foreground" />
        <Input placeholder={searchPlaceholder} className="h-9 pl-8" />
      </div>
      <div className="ml-auto flex items-center gap-2">{right}</div>
    </div>
  );
}
